



























export default
	props:
		card: Object

	computed:
		icon: -> @card.icon?[0]?.iconImage

